import { h } from './dom';

/** Short-lived messages ("Grill is full!") that never block play. */
export class Toaster {
  readonly el = h('div', { class: 'toasts', role: 'status', 'aria-live': 'polite' });
  private last = '';
  private lastAt = 0;

  show(text: string, kind: 'error' | 'info' | 'good' = 'error'): void {
    if (!text) return;
    const now = performance.now();
    if (text === this.last && now - this.lastAt < 700) return;
    this.last = text;
    this.lastAt = now;
    const el = h('div', { class: `toast toast--${kind}` }, text);
    this.el.append(el);
    while (this.el.childElementCount > 2) this.el.firstElementChild?.remove();
    setTimeout(() => {
      el.classList.add('is-out');
      setTimeout(() => el.remove(), 250);
    }, 1400);
  }

  clear(): void {
    this.el.replaceChildren();
  }
}
